import { useState } from 'react';
import { TextField } from '@mui/material';

export const styles = {
  '& .MuiInputBase-input': {
    textAlign: { xs: 'end', sm: 'center' },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '0 !important',
  },
};

type Props = {
  onEnterClick: (id: string, data: unknown) => void;
  marketId: string;
  defaultValue: number | null;
};

const MarketGroupsPositionInput = ({ onEnterClick, marketId, defaultValue }: Props) => {
  const [value, setValue] = useState<string>(defaultValue?.toString() || '');

  const handleValueUpdate = () => {
    const raw = value.trim();

    if (raw === '') {
      if (defaultValue === null) {
        return;
      }

      onEnterClick(marketId, { position: null });
      return;
    }

    const numberValue = Number(raw);

    if (isNaN(numberValue)) {
      setValue(defaultValue?.toString() || '');
      return;
    }

    if (numberValue === defaultValue) {
      return;
    }

    onEnterClick(marketId, { position: numberValue });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (newValue === '' || /^\d+$/.test(newValue)) {
      setValue(newValue);
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      onBlur={handleValueUpdate}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleValueUpdate();
        }
      }}
      sx={styles}
      slotProps={{
        htmlInput: {
          inputMode: 'numeric',
        },
      }}
    />
  );
};

export default MarketGroupsPositionInput;
